import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    canDeactivate: [BrowserBackGuard],
    children: [
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SgKdSharedRoutingModule { }
